/* eslint-disable import/no-cycle */
import { storagePipeline } from './storage';
import { trackingPipeline } from './tracking';
import { flowPipeline } from './flow';

export const pipeline = {
  storage: storagePipeline,
  tracking: trackingPipeline,
  flow: flowPipeline,
};
